/**
* © 2025. The EGT Universe. All Rights Reserved.
* License: Requires ACTIVE AppArtisan Subscription.
* Generated: Auto generated by Universe App Tools.
* 
* Namespace: scripto
* Filename: fields.schema
* Description: Schema for fields. This is used to validate fields and attributes.
*/
var fieldsManager = require("../uam/fields.js");
var registry = require("../uam/registry.js");
var _myRegistry = registry("uam.includes.fields.schema");

function validate(obj) {
    return fieldsManager.Validate(this.spec, obj);
}

function check(obj) {
    var chk = fieldsManager.Validate(this.spec, obj);
    if (!(chk.success)) {
        var nErr = new Error("Invalid schema.");
        nErr.namespace = "fields.schema.invalid";
        nErr.title = "Invalid Schema";
        nErr.description = "The schema is invalid.";
        nErr.data = chk;
        throw nErr;
    }
}

var $ = {};

$.events = {
    namespace: "events",
    spec: require("../fields/schema/event.json"),
    validate: validate,
    check: check
}
$.events.title = $.events.spec.title;
$.events.description = $.events.spec.description
$.events.type = $.events.spec.type;
_myRegistry.add($.events);


$._ = {
    // namespace: "events",
    registry: _myRegistry
};
module.exports = $;
